import type { JavascriptSerializable } from '#layers/data-model/public';

/**
 * Formats a curl command with auth, optional JSON body, and curl-safe URL flags.
 */
export function formatCurlSnippet(options: { method: string; url: string; body?: JavascriptSerializable }): string {
	// Curl treats brackets and braces as URL globs, so disable globbing for filter/include query strings.
	const hasSpecialChars = options.url.includes('[') || options.url.includes(']') || options.url.includes('{') || options.url.includes('}');
	const curlUrl = `${hasSpecialChars ? '-g ' : ''}"${options.url}"`;
	const methodFlag = options.method !== 'GET' ? `-X ${options.method} ` : '';
	const lines = [`curl ${methodFlag}${curlUrl} \\`];

	if (options.body === undefined) {
		lines.push('  -H "Authorization: Bearer YOUR_API_KEY"');

		return lines.join('\n');
	}

	lines.push(
		'  -H "Authorization: Bearer YOUR_API_KEY" \\',
		'  -H "Content-Type: application/json" \\',
		`  -d '${escapeSingleQuotedShellString(serializeJsonPayload(options.body))}'`,
	);

	return lines.join('\n');
}

/**
 * Serializes a REST body as pretty JSON while preserving undefined fields as null.
 */
function serializeJsonPayload(value: JavascriptSerializable): string {
	return JSON.stringify(value, (_key, propertyValue) => propertyValue === undefined ? null : propertyValue, 2) ?? 'null';
}

/**
 * Escapes a string so it can be wrapped in single quotes in a shell command.
 */
function escapeSingleQuotedShellString(value: string): string {
	return value.replaceAll('\'', String.raw`'\''`);
}
